import React from "react";
import { useSelector } from "react-redux";
import { Col } from "react-bootstrap";
import moment from "moment";

const AgeField = () => {
  const props = useSelector((state) => {
    return {
      birthdate: state.resident.birthdate,
      isStaffApp: state.config.isStaffApp,
    }
  });

  if (!props.birthdate) {
    return null;
  }

  return props.isStaffApp ? 
    <>
      <div className="item col-12 p-0">
        <div className="text-secondary unselectable">Age</div>
        <div className="pt-2 pb-4">{moment().diff(props.birthdate, "years")}</div>
      </div>
    </>:
    (
      <Col sm={3}>
        <div className="p-2">
          <div><strong>Age</strong></div>
          <div>{moment().diff(props.birthdate, "years")}</div>
        </div>
      </Col>
    )
};

export default AgeField;
